import { CallApi, handleJSONResponse } from './common';
import { TrackValidationResult } from '../../../../services/track/types/track-validation-result';

const callAPI = CallApi('tracks');

export const validateTracks = async (releaseId: string): Promise<TrackValidationResult[]> => {
  const url = `/${ releaseId }/validate`;

  const response = await callAPI(url, 'GET');

  return handleJSONResponse(response);
}
